import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { createSlice } from '@reduxjs/toolkit';

interface ConopFinalState {
  conopFinalData: {
    answer: string;
  } | null;
  isRegenerated?: boolean;
  title?: string;
}

const initialState: ConopFinalState = {
  conopFinalData: null,
  title: undefined,
};

const { name, reducer, actions } = createSlice({
  name: 'conopFinal',
  initialState,
  reducers: {
    setConopFinalData(state, action) {
      state.conopFinalData = action.payload;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const { setConopFinalData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setConopFinalData, setIsRegenerated, setTitle };

export const selectConopFinalData = (state: State) => state[name].conopFinalData;
export const selectIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectConopFinalTitle = (state: State) => state[name].title;
